import React, { ReactElement } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';

export const COPY = defineMessages({
  ADD_USERS: {
    id: 'ButtonUsers.addUsers',
    defaultMessage: 'Add users',
    description:
      '[Type: Label][Vis.: high] - This is the add users addon button on the header.',
  },
});

const ButtonUsers = (): ReactElement => {
  return (
    <Button
      size="sm"
      color="upgrade"
      href={createURL('/team/add/', {
        ut_source: 'header',
        ut_source3: 'webplat',
      })}
    >
      <T desc={COPY.ADD_USERS} />
    </Button>
  );
};

export default ButtonUsers;
